(function () {
	'use strict';

	a3_cabin_reports.factory('PaxInfoFactory', PaxInfoFactory);
	/**
	* @memberof CabinReports
	* @ngdoc factory
	* @name PaxInfoFactory
	* @description 
	*   Add, Update, Delete and Get Passenger information.
	* @ngInject
	*/
	function PaxInfoFactory($filter,IndexedDBService, localStorageMD5Service, SyncLogFactory, FlightFactory, CrewRouteFactory) {

		/**
		 * Initialize the PaxInfo
		 * @memberof PaxInfoFactory
		 */
		//TODO EPAP :: CLEAN
		function PaxInfo() {
			this.Id = null;
			this.STD_utc = null;
			this.STD_lcl = null;
			this.STA_utc = null;
			this.STA_lcl = null;
			this.AcType = null;
			this.Registration = null;
			this.ConfigurationC = null;
			this.ConfigurationY = null;
			this.PaxTotalC = null;
			this.PaxTotalY = null;
			this.MarketingFlightNos = null;
			this.SupplementaryInfo = null;
			this.LastRun = null;
			this.Offpoints = [];
			this.ConnFlights = [];
			this.Seatmap = [];
			this.curtainRows = [];
			this.Statistics = {};

			this.GetId = GetId;
		}

		var objType = 'PaxInfo';
		var objCallback = PaxInfo;

		var service =
		{
			setPaxInfoToStorage: setPaxInfoToStorage,
			getPaxInfoFromStorage: getPaxInfoFromStorage,
			getPaxInfoList: getPaxInfoList,
			updatePaxInfo: updatePaxInfo,
			getAllPaxInfoFromStorage: getAllPaxInfoFromStorage,
			cleanOldDataPaxInfo: cleanOldDataPaxInfo,
			setMaskPaxInfoInRoute: setMaskPaxInfoInRoute

		}

		migratePaxInfo();

		/**
	   * Overide default get Id
	   * @memberof PaxInfoFactory
	   * @returns {number} Id 
	   */
		function GetId() {
			return this.FlightId;
		}

		/**
	   * Set statistics and format passenger informtion of this flight
	   * @memberof PaxInfoFactory
	   * @param {paxInfo} paxInfo  The passenger information of a flight
	   * @returns {object} statistics
	   */
		//TODO EPAP CHANGE NAME
		function GetStatistics(paxInfo) {
			var statistics = {};
			var syncLog = SyncLogFactory.getSyncLog();

			if (paxInfo && paxInfo.Seatmap) {

				paxInfo.curtainRows = [];
				var cabinType;
				paxInfo.DHC = 0;

				for (var i = 0; i < paxInfo.Seatmap.length; i++) {
					for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {

						if (paxInfo.Seatmap[i].Columns[j].Cabin == 'J') {
							paxInfo.Seatmap[i].Columns[j].Cabin = 'Y';
						}



						if (cabinType == null) {
							cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
						}
						else if (cabinType != paxInfo.Seatmap[i].Columns[j].Cabin && paxInfo.Seatmap[i - 1] && paxInfo.Seatmap[i].Columns[j].Cabin != null) {
							cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
							paxInfo.curtainRows.push(paxInfo.Seatmap[i - 1].RowNo);
						}
					}
				}
			}

			return statistics;
		}

		/**
		 * Set Passenger information
		 * @memberof PaxInfoFactory
		 * @param {Array} paxInfos  The passenger informations 
		 */
		function setPaxInfoToStorage(paxInfo, flightIds) {
			if (paxInfo) {
				// get paxInfo for the flights with draft reports from indexedDB (gets the new paxInfo if the flightId exists in sync response)
				getAllPaxInfoFromStorage(function (paxInfoResult) {
					var oldDraftPaxInfo = [];
					var paxInfoFlightIds = paxInfo.map(function (item) {
						return item.FlightId;
					});

					oldDraftPaxInfo = paxInfoResult.filter(function (item) {
						return flightIds.includes(item.FlightId) &&
							!paxInfoFlightIds.includes(item.FlightId);
					});
					// get new paxInfo
					IndexedDBService.removeAll(objType).then(function () {
						for (var i = 0; i < paxInfo.length; i++) {
							paxInfo[i].Statistics = GetStatistics(paxInfo[i]);
						}
						var newListPaxInfo = paxInfo.concat(oldDraftPaxInfo);
						IndexedDBService.addAll(objType, newListPaxInfo);

					});
				})

			}
		}
		/**
		 * Clean Old Data
		 * @memberof PaxInfoFactory
		 * @param {Array} pendingFlightIds FlightIds with pending reports
		 */
		function cleanOldDataPaxInfo(pendingFlightIds) {
			// get paxInfo for the flights with draft reports from indexedDB (gets the new paxInfo if the flightId exists in sync response)
			var now = moment();
			getAllPaxInfoFromStorage(function (paxInfoResult) {
				var oldDraftPaxInfo = paxInfoResult.filter(function (item) {
					return pendingFlightIds.includes(item.FlightId);
				});
				// keep only the pax list with pending reports
				IndexedDBService.removeAll(objType).then(function () {
					IndexedDBService.addAll(objType, oldDraftPaxInfo);
				});
			})

		}
		/**
		 * Get Passenger information for the selected flight
		 * @memberof PaxInfoFactory
		 * @param {number} flightId  The flight id 
		 */
		function getPaxInfoFromStorage(flightId, callback) {
			//var intFlightId = 1226541;
			var intFlightId = +flightId;

			IndexedDBService.getById(objType, intFlightId).then(function (result) {
				// applyDummyTierDataForTestFlight(result, intFlightId);
				callback(result);
			});
		}

		
		/**
		 * Get Passenger information list for the selected flight
		 * @memberof PaxInfoFactory
		 * @param {number} flightId  The flight id 
		 */
		function getPaxInfoList(flightId, callback) {
			var intFlightId = +flightId;
			var passengerList = [];

			IndexedDBService.getById(objType, intFlightId).then(function (paxInfo) {
				if (paxInfo) {
					for (var i = 0; i < paxInfo.Seatmap.length; i++) {
						for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
							var passenger = paxInfo.Seatmap[i].Columns[j];
							if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
								passengerList.push(passenger);
							}
						}
					}
				}
				callback(passengerList);
			});
		}

		/**
		* Get Passenger information for the selected flights
		* @memberof PaxInfoFactory
		*/
		function getAllPaxInfoFromStorage(callback) {
			IndexedDBService.getAll(objType).then(function (paxinfo) {
				callback(paxinfo);
			});
		}

		/**
		 * Update Passenger information
		 * @memberof PaxInfoFactory
		 * @param {object} paxInfo  The passenger informations 
		 */
		function updatePaxInfo(paxInfo) {
			if (paxInfo) {
				paxInfo.Statistics = GetStatistics(paxInfo);
				IndexedDBService.put(objType, paxInfo);
			}
		}

		/**
		 * Update Passenger information
		 * @memberof PaxInfoFactory
		 */
		function migratePaxInfo() {
			var lsPaxInfo = localStorageMD5Service.get(objType);
			if (lsPaxInfo && lsPaxInfo.length > 0) {
				IndexedDBService.addAll(objType, lsPaxInfo);
				localStorageMD5Service.remove(objType);
			}
		}

		/**
		 * Hide pax name with condition
		 * @memberof PaxInfoFactory
		 */
		function setMaskPaxInfoInRoute(flightInfo){
			if(flightInfo && flightInfo.showPaxNames){
				var applyMask = false;
				var flights = CrewRouteFactory.getCrewRouteFlights(flightInfo.DutyNo, flightInfo.DutyDay, flightInfo.FlightDate);  
				flights = $filter('orderBy')(flights, 'ScheduledDeparture');
				var lastFlight = flights[flights.length - 1];
				
				//TODO:: temporary comment just to test, uncomment it on deploy !!
				if(moment.utc().diff(moment(lastFlight.ATA), 'hours') > 6){
					//set mask
					applyMask = true;

				} 
				// else if (moment.utc().diff(moment(lastFlight.ETA), 'hours') > 4) {
				// 	//set mask
				// 	applyMask = true;
				// }
				
				// else if (moment.utc().diff(moment(lastFlight.ScheduledArrival), 'hours') > 4) {
				// 	//set mask
				// 	applyMask = true;
				// }

				if(applyMask){
					flights.forEach(function(flight){
						flight.showPaxNames = false;
						FlightFactory.updateFlight(flight)
					});
					var flightIds = flights.map(function (item) {
						return item.FlightId; // or Id (todo: check)
					});

					setMaskPaxInfoToStorage(flightIds);
				}
			}
		}

		function setMaskPaxInfoToStorage(flightIds) {
			getAllPaxInfoFromStorage(function (paxInfoResult) {
				var maskedPaxFlightList = [];
				maskedPaxFlightList = paxInfoResult.filter(function (item) {
					return flightIds.includes(item.FlightId);
				});
				for (var i = 0; i < maskedPaxFlightList.length; i++) {
					maskPaxNames(maskedPaxFlightList[i]);
				}
				var otherPaxInfo = paxInfoResult.filter(function (item) {
					return !flightIds.includes(item.FlightId);
				});

				// get new paxInfo
				IndexedDBService.removeAll(objType).then(function () {
					var newListPaxInfo = otherPaxInfo.concat(maskedPaxFlightList);
					IndexedDBService.addAll(objType, newListPaxInfo);
				});
			})
		}

		function maskPaxNames(pax){
			if (pax) {
				for (var i = 0; i < pax.Seatmap.length; i++) {
					for (var j = 0; j < pax.Seatmap[i].Columns.length; j++) {
						var passenger = pax.Seatmap[i].Columns[j];
						if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
							passenger.InfantName = passenger.InfantName ? "*****" : passenger.InfantName;
							passenger.InfantSurname = passenger.InfantSurname ? "*****" : passenger.InfantSurname;
							passenger.InfantGivenName = passenger.InfantGivenName ? "*****" : passenger.InfantGivenName;
							passenger.Fullname = passenger.Fullname ? "***** *****" : passenger.Fullname;
							passenger.Surname = passenger.Surname ? "*****" : passenger.Surname;
							passenger.GivenName = passenger.GivenName ? "*****" : passenger.GivenName;
						}
					}
				}
			}
		}

		/**
		 * Temporary dummy tier data for manual verification on a specific flight.
		 * Applies in-memory only when pax info is read from storage.
		 * @memberof PaxInfoFactory
		 * @param {object} paxInfo The passenger information
		 * @param {number} flightId The flight id
		 */
		function applyDummyTierDataForTestFlight(paxInfo, flightId) {
			if (!paxInfo || +flightId !== 1226977 || !paxInfo.Seatmap) {
				return;
			}

			var passengers = [];
			paxInfo.Seatmap.forEach(function (row) {
				row.Columns.forEach(function (column) {
					if (!column.IsEmptySeat && column.SeatMode == "Seat") {
						passengers.push(column);
					}
				});
			});

			if (passengers.length < 6) {
				return;
			}

			var tierAssignments = [
				{ TierLevel: "PLTM", TierDescription: "Platinum", Carrier: "A3" },
				{ TierLevel: "GLDT", TierDescription: "Gold", Carrier: "A3" },
				{ TierLevel: "SLVT", TierDescription: "Silver", Carrier: "A3" },
				{ TierLevel: "BLUT", TierDescription: "Blue", Carrier: "A3" },
				{ TierLevel: "PLTM", TierDescription: "Platinum", Carrier: "A3" },
				{ TierLevel: "GLDT", TierDescription: "Gold", Carrier: "A3" }
			];

			tierAssignments.forEach(function (tierData, index) {
				var passenger = passengers[index];
				if (!passenger) {
					return;
				}

				passenger.Fqtv = passenger.Fqtv || {};
				passenger.Fqtv.Carrier = tierData.Carrier;
				passenger.Fqtv.TierLevel = tierData.TierLevel;
				passenger.Fqtv.TierDescription = tierData.TierDescription;
				passenger.Fqtv.Number =
					passenger.Fqtv.Number || "TEST" + String(index + 1).padStart(4, "0");
			});

			recalculateDummyTierSummaries(paxInfo);
		}

		/**
		 * Recalculates tier summaries so counters match the injected test data.
		 * @memberof PaxInfoFactory
		 * @param {object} paxInfo The passenger information
		 */
		function recalculateDummyTierSummaries(paxInfo) {
			if (!paxInfo || !paxInfo.Seatmap) {
				return;
			}

			paxInfo.PassengerSummaryC = paxInfo.PassengerSummaryC || {};
			paxInfo.PassengerSummaryY = paxInfo.PassengerSummaryY || {};

			paxInfo.PassengerSummaryC.FQTVPlatinum = 0;
			paxInfo.PassengerSummaryY.FQTVPlatinum = 0;
			paxInfo.PassengerSummaryC.FQTVGold = 0;
			paxInfo.PassengerSummaryY.FQTVGold = 0;
			paxInfo.PassengerSummaryC.FQTVSilver = 0;
			paxInfo.PassengerSummaryY.FQTVSilver = 0;

			paxInfo.Seatmap.forEach(function (row) {
				row.Columns.forEach(function (column) {
					if (
						column.IsEmptySeat ||
						column.SeatMode != "Seat" ||
						!column.Fqtv ||
						!column.Cabin
					) {
						return;
					}

					var summary =
						column.Cabin == "C"
							? paxInfo.PassengerSummaryC
							: paxInfo.PassengerSummaryY;

					if (column.Fqtv.TierLevel == "PLTM") {
						summary.FQTVPlatinum++;
					} else if (column.Fqtv.TierLevel == "GLDT") {
						summary.FQTVGold++;
					} else if (
						column.Fqtv.TierLevel == "SLVT" ||
						column.Fqtv.TierLevel == "BLUT"
					) {
						summary.FQTVSilver++;
					}
				});
			});
		}

		return service;
	}

})();
